import * as yup from 'yup';

export const CategoryFormValidation = yup.object().shape({
    description: yup.string().required('Campo é obrigatória'),
});